<template>
    <div>
      <div v-for="c in list" :key="c.Id" :class="c.check?'active_card_item':'card_item'" @click="handleCheckboxChange(c)">
        <div class="flex_box">
          <div class="flex-box-label__open" v-if="c.isOpen === '1'">已开放</div>
          <div class="flex-box-label__close" v-if="c.isOpen === '0' || c.isOpen === 'null' || !c.isOpen">未开放</div>
          <div class="flex-box-title">
            <p>{{ c.labName }}</p>
          </div>
          <el-checkbox v-if="c.isOpen === '1'" style="font-size: 12px;" class="custom-checkbox" @change="handleCheckboxChange(c)" v-model="c.check"></el-checkbox>
        </div>
        <div class="labj-content">
          <div class="content" :style="{height: !c.expand ? '21px': 'auto', overflow: 'hidden',minHeight: '21px'}">
            <div v-if="c.labJj && c.labJj !=='null'" v-html="c.labJj"></div>
            <div v-else>暂无简介</div>
          </div>
          <div :class="c.expand ? 'expand' : 'not-expand'" @click="toggleExpand(c.labId)"></div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            list: Array,
            default: []
        },
    },
    data() {
        return {
          
        }
    },
    methods: {
      toggleExpand(id){
        this.$emit('toggleExpand', id)
      },
      handleCheckboxChange(cItem){
        if(cItem.isOpen !== '1') return
        this.$emit('handleCheckboxChange', cItem.Id)
      },
    },
    mounted() { 
    } 
}
</script>
<style scoped lang="less">
  .expand {
    width:15px;
    height:20px;
    background: url("../../../assets/apply/expand.png") no-repeat center;
  }
  .not-expand {
    width:15px;
    height:20px;
    background: url("../../../assets/apply/notexpand.png") no-repeat center;
  }
  .card_item {
    width: 100%;
    box-shadow: 0 1px 4px 0 #00000014;
    border-radius: 8px;
    background-color: #fff;
    margin-bottom: 10px;
    padding:15px;
    p{
      font-size: 16px;color: #333333;font-weight: 400;
    }
  }
  .active_card_item{
    width: 100%;
    border: 1px dashed #13499B;
    box-shadow: 0 1px 4px 0 #00000014;
    border-radius: 8px;
    margin-bottom: 10px;
    padding:15px;
    background-color: #fff;
    p{
      font-size: 16px;
      font-weight: 400;
      color:#13499B
    }
  }
  .flex_box{
    width: 100%;
    display: flex;
    align-items: center;
  }
  .flex_box .flex-box-title {
    display: flex;
    flex: 1;
    align-items: center;
  }
  .flex_box .flex-box-label__open {
    font-weight: normal;
    margin-right:10px;
    font-size: 12px;
    padding: 0 6px;
    line-height: 21px;
    width:50px;
    background-color: #32A780;
    color: #ffffff;
  }
  .flex_box .flex-box-label__close {
    font-weight: normal;
    margin-right:10px;
    font-size: 12px;
    padding: 0 6px;
    width:50px;
    line-height: 21px;
    background-color: #E8E9EA;
    color: #73767D;
  }
  .labj-content {
    width:100%;
    padding: 15px;
    background-color: #F6F8FB;
    margin-top:15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .labj-content .content {
    width:95%;
    padding-right: 10px;
    margin-right:10px;
    border-right: 1px dotted #8A9491;
  }
  .custom-checkbox ::v-deep .el-checkbox__inner {
    width: 20px;           /* 调整宽度 */
    height: 20px;          /* 调整高度 */
    border-radius: 50%;    /* 圆角 */
    background-color: #fff;
  }

  /* 确保勾选标记也适应新的尺寸 */
  .custom-checkbox ::v-deep .el-checkbox__inner::after {
    left: 5px;             /* 调整位置 */
    top: 1px;
    width: 5px;            /* 调整宽度 */
    height: 10px;          /* 调整高度 */
    border-width: 2px;     /* 调整线条粗细 */
    transform: rotate(45deg) scaleY(1); /* 确保对号显示正常 */
  }

  /* 当复选框被选中时的样式 */
  .custom-checkbox ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #13499b; /* 选中时背景颜色 */
    border-color: #13499b;     /* 选中时边框颜色 */
  }

  /* 处理鼠标悬停效果 */
  .custom-checkbox ::v-deep .el-checkbox__inner:hover {
    border-color: #c6e2ff; /* 悬停时边框颜色 */
  }

</style>